import { makeStyles } from '@material-ui/core';
import { efesError } from '../../../../theme';

const useStyles = makeStyles((theme) => ({
  subTitleRow: {
    fontSize: '1rem',
    margin: '0.5rem 0',
  },
  minusIcon: {
    cursor: 'pointer',
    fontSize: 20,

  },
  removeIcon: {
    color: efesError,
  },
  addIcon: {
    color: theme.palette.primary.main,
  },
  plusIcon: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: 'max-content',
    marginTop: 20,
    marginBottom: 10,
    fontSize: 20,
    cursor: 'pointer',

    '& i': {
      fontSize: 20,
    },
    '& p': {
      lineHeight: '19px',
      marginLeft: 3,
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
